import React from "react";
import { BsTwitter, BsInstagram, BsLinkedin } from "react-icons/bs";
import { FaFacebookF } from "react-icons/fa";

const SocialMedia = () => (
  <div className='app__social'>
    <div>
      <a href='https://twitter.com/zeusgroupng'>
        <BsTwitter />
      </a>
    </div>
    <div>
      <a href='https://www.linkedin.com/in/jackson-chukwurah/'>
        <BsLinkedin />
      </a>
    </div>
    <div>
      <a href='https://www.instagram.com/zeusgeeks/'>
        <BsInstagram />
      </a>
    </div>
  </div>
);

export default SocialMedia;
